import React from 'react';

import { BlogLayout } from 'components/layout';
import { TRANSLATIONS } from 'constants/translations';
import { createStaticPaths, prefetchConfig } from 'helpers/ServerHelpers';
import { withSSGPage } from 'hoc/WithServerPage/withSSGPage';
import { prefetchContentfulLandingPage, useContentfulLandingPage } from 'hooks/data/useContentfulLandingPage';
import { BetaTemplate } from 'templates/LandingPages';
import styles from 'templates/LandingPages/AlphaTemplate/AlphaTemplate.module.scss';

import type { NextPageWithLayout } from 'types';
import { ContentfulLandingPageType, PageType } from 'types';

const SLUG = 'beneficii';

export const getStaticPaths = createStaticPaths();

export const getStaticProps = withSSGPage(async (context, props) => {

  const { slug, queryClient, preview } = props;

  if (slug) {
    return { notFound: true };
  }

  const [landingPage] = await Promise.all([
    prefetchContentfulLandingPage(queryClient, { preview, type: ContentfulLandingPageType.Beta, slug: SLUG }),
    prefetchConfig(queryClient)
  ]);

  // Check if not found
  if (!landingPage) {
    return { notFound: true };
  }

  return {
    props: {
      pageSlug: SLUG,
      type: ContentfulLandingPageType.Beta
    }
  };
}, {
  translations: [TRANSLATIONS.COMMON, TRANSLATIONS.CAMPAIGNS],
  pageType: PageType.Upgreat,
  revalidate: false
});

const Page: NextPageWithLayout<PageType.Upgreat, {type: ContentfulLandingPageType, pageSlug: string}> = (props) => {
  const { preview, pageSlug, type } = props;

  const { data } = useContentfulLandingPage({ type, slug: pageSlug, preview });

  return <BetaTemplate data={data} />;
};

Page.getLayout = (page, { preview }) => (
  <BlogLayout
    {...layoutProps}
    preview={preview}
  >
    {page}
  </BlogLayout>
);

const layoutProps = {
  containerClassName: styles.layoutContainer,
  contentClassName: styles.layoutContent,
};

export default Page;
